module.exports = __webpack_public_path__ + "static/img/luxiangjilu.e88125b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/luxiangjilu.png
// module id = CEQ3
// module chunks = 24